if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (formData.has("quantity")) {

        } else {
          let q = this.form.querySelector('[name="quantity"]');
          if(q) {
            formData.append('quantity', q.value);
          }
        }

        // Check for gift box checkbox
        const giftBoxForm = this.closest('product-info')?.querySelector('gift-box-form');
        const addGiftBox = giftBoxForm?.isChecked || false;
        const giftBoxProductId = giftBoxForm?.giftBoxProductId;

        if (addGiftBox && giftBoxProductId) {
          this.addProductsWithGiftBox(formData, giftBoxProductId, config, evt);
        } else {
          this.addSingleProduct(formData, config, evt);
        }
      }

      addProductsWithGiftBox(formData, giftBoxProductId, config, evt) {
        const mainProductId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const timestamp = Date.now();

        // Build items array - create separate bundle for each quantity
        // Each bundle: 1 gift box (parent) + 1 coffee (child)
        const items = [];
        for (let i = 0; i < quantity; i++) {
          const bundleId = `gift-box-${timestamp}-${i}`;
          items.push(
            {
              id: parseInt(giftBoxProductId),
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                _bundle_type: 'gift-box',
                _bundle_role: 'parent'
              }
            },
            {
              id: parseInt(mainProductId),
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                _bundle_type: 'gift-box',
                _bundle_role: 'child'
              }
            }
          );
        }

        const payload = { items };

        // Add sections for cart drawer update
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        // Single fetch with JSON body - must use .js endpoint for JSON response
        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then((response) => response.json())
          .then((response) => {
            // Check for error status (422, 404, etc.) - multi-item success has no status property
            if (response.status && typeof response.status === 'number') {
              this.handleAddError(response, formData);
              return;
            }
            this.handleAddSuccess(response, formData);
          })
          .catch((e) => {
            console.error('Gift box bundle add failed:', e);
          })
          .finally(() => {
            this.resetButtonState(evt);
          });
      }

      addSingleProduct(formData, config, evt) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleAddError(response, formData);
              return;
            }
            this.handleAddSuccess(response, formData);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.resetButtonState(evt);
          });
      }

      handleAddError(response, formData) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
      }

      handleAddSuccess(response, formData) {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }
      }

      resetButtonState(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent("add:user-action", evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
